<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>รหัสชีท</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="replace_form.code"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ชื่อชีท</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="replace_form.name"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนชีทคงเหลือ (ม้วน)</label>
            </b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="replace_form.quantity"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนที่นำเข้า (ม้วน)</label>
            </b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="number"
                    v-model="form.quantity"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>เครื่องผลิตชีท</label>
            </b-col>
            <b-col sm="6">
                <multiselect
                    v-model="form.machine"
                    :options="optionMachine"
                    label="name"
                    track-by="name">
                </multiselect>
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                        :disabled="form.onSave"
                    type="button"
                    class="btn btn-success"
                    @click="onSubmitImportSheet">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button"
                        @click="cancelModal"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
         <!--<pre class="alert alert-primary">{{ replace_form }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
    name: "import-sheet-modal",
    components: { Multiselect },
    data() {
        return {
            form: {
                quantity: "",
                reason: "",
                code: "",
                machine : "",
                onSave: false,
            }
        };
    },
    created(){
      this.$store.dispatch('Machine/getMachineSheet');
    },
    computed: {
        ...mapState({
            replace_form: state => {
                return state.Sheet.form;
            },
            user: state => {
                return state.Auth.user;
            },
            optionMachine: state =>{
                return state.Machine.machine_sheet;
            }
        })
    },
    methods: {
        //function
        onSubmitImportSheet() {
            if(!this.form.quantity || this.form.quantity < 0){
                alert("กรุณาใส่จำนวนให้ถูกต้อง");
            }
            else{
                let data = {
                    sheet_id : this.replace_form.id,
                    sheet_type_id : this.replace_form.sheet_type.id,
                    quantity: this.form.quantity,
                    machine_id: this.form.machine.id,
                    user_id: this.user.id
                };
                this.form.onSave = true;
                this.$emit("submit", data);
                this.form ={
                    quantity: "",
                    reason: "",
                    code: "",
                    machine : "",
                    onSave: false,
                }
            }

        },
        cancelModal(){
            this.$emit("submit", "cancel");
            this.form ={
                quantity: "",
                reason: "",
                code: "",
                machine : "",
                onSave: false,
            }
        }
    }
};
</script>

<style scoped></style>
